import {FBFieldWithPriceBaseOptions, PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";


import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {OptionItem} from "FormBuilder/Fields/Options/OptionItem";
import {StoreDataType} from "shared/core/Store/StoreBase";
import {FBMultipleOptionsBaseOptions} from "FormBuilder/Fields/Core/FBMultipleOptionsBase.Options";


export class FBRadioOptions extends FBMultipleOptionsBaseOptions{
    public Placeholder:string;



    protected LoadDefaultValues() {
        super.LoadDefaultValues();

        this.Type=FieldTypeEnum.Radio;
        this.Label='Radio';
        this.Placeholder='';
        this.PriceType=PriceTypeEnum.options;

    }


}

